import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';

@Component({
  selector: 'ff-table-header',
  templateUrl: './table-header.component.html',
  styleUrls: ['./table-header.component.scss']
})
export class TableHeaderComponent implements OnInit {
  
  @ViewChild('headerTemplate') template: TemplateRef<any>;

  constructor() { }

  ngOnInit(): void {
  }

}
